import api from '../utils/api'
import getDeviceId from '../utils/deviceId'

import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import useFlashMessage from './useFlashMessage'

export default function useAuth() {
    const [authenticated, setAuthenticated] = useState(false)
    const [userName, setUserName] = useState()
    const { setFlashMessage } = useFlashMessage()
    const navigate = useNavigate()

    useEffect(() => {
        const token = localStorage.getItem('token')
        const userStorageName = localStorage.getItem('userName')

        if (token) {
            // Authorization e X-Device-Id já são setados em api.js na avaliação do
            // módulo (antes de qualquer render) — não precisa repetir aqui.
            setAuthenticated(true)
            setUserName(userStorageName)
        }
    }, [])

    async function register(user) {
        let msgText = 'Cadastro realizado com sucesso!'
        let msgType = 'success'
        try {
            const { data } = await api.post('/user/register', { ...user, deviceId: getDeviceId() })
            msgText = data.message
            navigate('/login')
        } catch (error) {
            msgText = error.response?.data?.message || 'Não foi possível concluir o cadastro'
            msgType = 'error'
        }
        setFlashMessage(msgText, msgType)
    }

    async function login(user) {
        let msgText = 'Login realizado com sucesso!'
        let msgType = 'success'
        let errorCode

        try {
            const data = await api.post('/user/login', { ...user, deviceId: getDeviceId() }).then((response) => response.data)
            await authUser(data)
        } catch (error) {
            msgText = error.response?.data?.message || 'Não foi possível entrar'
            msgType = 'error'
            errorCode = error.response?.data?.code
        }
        setFlashMessage(msgText, msgType)
        return { errorCode }
    }

    async function resendVerification(email) {
        let msgText
        let msgType = 'success'
        try {
            const { data } = await api.post('/user/resend-verification', { email })
            msgText = data.message
        } catch (error) {
            msgText = error.response?.data?.message || 'Não foi possível reenviar a confirmação'
            msgType = 'error'
        }
        setFlashMessage(msgText, msgType)
    }

    async function forgotPassword(email) {
        let msgText
        let msgType = 'success'
        try {
            const { data } = await api.post('/user/forgot-password', { email })
            msgText = data.message
        } catch (error) {
            msgText = error.response?.data?.message || 'Não foi possível enviar o link de redefinição'
            msgType = 'error'
        }
        setFlashMessage(msgText, msgType)
    }

    async function resetPassword(token, password, confirmPassword) {
        let msgText
        let msgType = 'success'
        let ok = false
        try {
            const { data } = await api.post(`/user/reset-password/${token}`, { password, confirmPassword })
            msgText = data.message
            ok = true
            navigate('/login')
        } catch (error) {
            msgText = error.response?.data?.message || 'Não foi possível redefinir a senha'
            msgType = 'error'
        }
        setFlashMessage(msgText, msgType)
        return { ok }
    }

    async function authUser(data) {
        setAuthenticated(true)
        setUserName(data.userName)

        localStorage.setItem('userName', data.userName)
        localStorage.setItem('token', JSON.stringify(data.token))

        // Sem isso, as primeiras requisições após o login (antes de qualquer
        // reload de página) saem sem Authorization/X-Device-Id — só o
        // useEffect de mount setava esses headers, por isso um reload bruto
        // era usado até agora só pra forçar esse efeito a rodar de novo.
        api.defaults.headers.Authorization = `Bearer ${data.token}`
        api.defaults.headers['X-Device-Id'] = getDeviceId()

        navigate('/perfil')
    }

    async function logout() {
        setAuthenticated(false)
        setUserName(undefined)

        localStorage.removeItem('token')
        localStorage.removeItem('userName')
        api.defaults.headers.Authorization = undefined

        navigate('/login')
        setFlashMessage('Logout realizado com sucesso!', 'success')
    }

    return { authenticated, userName, register, login, logout, resendVerification, forgotPassword, resetPassword }
}
